import { useEffect, useState, useContext } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

const PAGE_SIZE = 20;

const toOption = (p) => ({
  label: p.status === "DRAFT" ? `${p.name} (Draft)` : p.name,
  value: p.shopifyMetaobjectId,
});

const ProducerSelector = ({ value, onChange }) => {
  const { getToken } = useContext(AuthContext);
  const [producers, setProducers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchProducers = async (params) => {
    const res = await fetchWithInterceptor(`/api/producers?${new URLSearchParams(params)}`, {
      headers: {
        "x-access-token": getToken(),
      },
    });
    if (!res.ok) return null;
    const { rows } = await res.json();
    return rows.map(toOption);
  };

  useEffect(() => {
    if (!value) {
      setSelected(null);
      return;
    }
    if (selected?.value === value) return;

    let active = true;
    fetchProducers({ shopifyMetaobjectId: value, limit: 1 })
      .then((rows) => {
        if (active && rows) setSelected(rows[0] || null);
      })
      .catch((err) => console.error("Error fetching producer", err));

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    let active = true;
    const timer = setTimeout(async () => {
      try {
        setLoading(true);
        const rows = await fetchProducers({ name: search, limit: PAGE_SIZE });
        if (active && rows) setProducers(rows);
      } catch (err) {
        console.error("Error fetching producers", err);
      } finally {
        if (active) setLoading(false);
      }
    }, 400);

    return () => {
      active = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Autocomplete
      fullWidth
      options={
        selected && !producers.some((p) => p.value === selected.value)
          ? [selected, ...producers]
          : producers
      }
      value={selected}
      loading={loading}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      getOptionLabel={(option) => option.label}
      filterOptions={(opts) => opts}
      onInputChange={(event, inputValue) => setSearch(inputValue)}
      onChange={(event, newValue) => {
        setSelected(newValue);
        onChange(newValue?.value || "");
      }}
      renderInput={(params) => (
        <TextField {...params} label="Producer" size="small" fullWidth />
      )}
    />
  );
};

export default ProducerSelector;
